let moreButton = document.querySelector('section.newsletter button.see-all');
if(moreButton) {
    let newsletters = document.querySelectorAll('section.newsletter .links a');
    moreButton.addEventListener('click', function() {
        moreButton.classList.remove('show');
        newsletters.forEach(function(newsletter, index) {
            newsletter.classList.add('show');
        });
    });
}